import React from 'react';

export default function Container(props) {
  return (
    <div className="container flex mt-10 p-20">
      <div className="col-12 flex">
        {props.children}
      </div>
    </div>
  )
}